module.exports = __webpack_public_path__ + "img/excluded_area_none.9bf5d3c4.svg";